import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues5, LocalService, PageKey, Wrappers5 } from '../../../service/local.service';
import { B2bService } from 'src/service/b2b.service';
import { KeyValueId } from 'src/app/supporting/receiptPrint';

@Component({
  selector: 'app-b2b-accounts',
  templateUrl: './b2b-accounts.component.html',
  styleUrl: './b2b-accounts.component.scss'
})
export class B2bAccountsComponent {
  lstSectionConfigKeys: string[] = ["b2b", "table"];
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;

  source: Wrappers5; maxBodyHeight = 0;
  isB2bAccountPopupOpen: boolean = false; isB2bOwnerPopupOpen: boolean = false; selectedB2bAccountId: string = '';

  isActionPopupOpen: boolean = false; actionTitle: string = ''; moreActionItems: KeyValues5[] = [];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private router: Router, private languageManagementService: LanguageManagementService, private b2bService: B2bService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.B2BAccountAdmin);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  onLoad() {
    this.b2bService.getB2bAccounts(this.source?.paging).subscribe(result => {
      this.source = result;
    });
  }

  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.selected.countryCode) {
      const ctryCode = this.localService.selected.countryCode == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.selected.countryCode + '-' + this.localService.asCtryCode);

      this.router.navigate([['/b2b-accounts', ctryCode, this.localService.selected.user, InteractionType.Bill_PnixSoft].join('/')]);
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedB2bAccountId = key;
        this.isB2bAccountPopupOpen = true;
      } break;
      case 2: {
        this.selectedB2bAccountId = key;
        this.isB2bOwnerPopupOpen = true;
      } break;
      case 3: {
        const item = this.source.items.find(x => x.key == key);
        this.actionTitle = item?.v2 ?? '';
        this.moreActionItems = [
          {
            key: '1',
            isSelected: true,
            v1: this.localService.languageContent.common['edit'],
            v2: 'edit',
            v3: key,
          } as KeyValues5,
          {
            key: '2',
            isSelected: true,
            v1: this.localService.languageContent.b2b['owners'],
            v2: 'groups',
            v3: key,
          } as KeyValues5,
          {
            key: '3',
            v1: 'B2B Plan Purchase',
            v2: 'view_timeline',
            v3: ['/invoice-from-pnixsoft', this.ctryCode, this.localService.selected.user, 4, 5, key].join('/')
          } as KeyValues5,
          {
            key: '4',
            v1: 'License to Business',
            v2: 'receipt',
            v3: ['/invoice-to-biz', this.ctryCode, this.localService.selected.user, 4, 2, key, '0'].join('/')
          } as KeyValues5,
          {
            key: '5',
            v1: 'B2B Licenses',
            v2: 'assignment',
            v3: ['/b2b-licenses', this.ctryCode, this.localService.selected.user, 4, key].join('/')
          } as KeyValues5,
        ];
        this.isActionPopupOpen = true;
      } break;
    }
  }

  onMoreActionClicked(keyId: KeyValueId) {
    switch (keyId.key) {
      case '1': {
        this.onAction(1, keyId.value);
      } break;
      case '2': {
        this.onAction(2, keyId.value);
      } break;
    }
  }
}
